export interface PickupCommonType {
    value: number;
    labelCn: string;
    labelEn: string;
    labelEs: string;
}

// 揽收单位类型
export const UnitOptions: PickupCommonType[] = [
    {value: 1, labelCn: '件' ,labelEn: 'Piece', labelEs: 'Pieza(S)'},
    {value: 2, labelCn: '袋' ,labelEn: 'Bag', labelEs: 'Bolsa(S)'},
    {value: 3, labelCn: '箱' ,labelEn: 'Carton', labelEs: 'Caja(S)'},
    {value: 4, labelCn: '托' ,labelEn: 'Pallet', labelEs: 'Palé(S)'}
];

export const getUnitLabel = (unitValue: number, language: string = 'zh-CN'): string => {
    const unit = UnitOptions.find(option => option.value === unitValue);
    if (!unit) return '';
    const isEnglish = language.startsWith('en');
    const isSpanish = language.startsWith('es');
    return isEnglish ? unit.labelEn : isSpanish ? unit.labelEs : unit.labelCn;
};

//营业日期
export const weekdaysOptions = [
    {value: 1, labelCn: '星期一' ,labelEn: 'Monday', labelEs: 'Lunes'},
    {value: 2, labelCn: '星期二' ,labelEn: 'Tuesday', labelEs: 'Martes'},
    {value: 3, labelCn: '星期三' ,labelEn: 'Wednesday', labelEs: 'Miércoles'},
    {value: 4, labelCn: '星期四' ,labelEn: 'Thursday', labelEs: 'Jueves'},
    {value: 5, labelCn: '星期五' ,labelEn: 'Friday', labelEs: 'Viernes'},
    {value: 6, labelCn: '星期六' ,labelEn: 'Saturday', labelEs: 'Sábado'},
    {value: 7, labelCn: '星期日' ,labelEn: 'Sunday', labelEs: 'Domingo'}
];

// 工具函数：根据businessDays数组和语言获取星期显示文本
export const getBusinessDaysText = (businessDays: number[], language: string = 'zh-CN'): string => {
    if (!businessDays || businessDays.length === 0) {
        return '';
    }
    
    const isEnglish = language.startsWith('en');
    const isSpanish = language.startsWith('es');
    const dayTexts = [...businessDays] // 创建数组副本，避免修改原数组
        .sort((a, b) => a - b) // 按数值排序
        .map(dayValue => {
            const weekday = weekdaysOptions.find(option => option.value === dayValue);
            return weekday ? (isEnglish ? weekday.labelEn : isSpanish ? weekday.labelEs : weekday.labelCn) : '';
        })
        .filter(text => text !== ''); // 过滤掉空字符串
    
    return dayTexts.join(isEnglish ? ', ' : '、');
};
export interface PickupFailureReason {
    code: string;
    labelCn: string;
    labelEn: string;
    labelEs: string;
}
// 揽收失败原因
export const pickupFailureReasons:PickupFailureReason[] = [
    {code: 'ERPU001', labelCn: '地址错误', labelEn: 'Wrong Address', labelEs: 'Dirección Incorrecta'},
    {code: 'ERPU002', labelCn: '仓库关闭', labelEn: 'Warehouse Closed', labelEs: 'Almacén Cerrado'},
    {code: 'ERPU003', labelCn: '联系电话是空号', labelEn: 'Invalid Phone Number', labelEs: 'Número de Teléfono Inválido'},
    {code: 'ERPU004', labelCn: '联系不上仓库负责人', labelEn: 'Cannot Reach Contact', labelEs: 'No se Puede Contactar al Responsable'},
    {code: 'ERPU005', labelCn: '转交其他承运商', labelEn: 'Handed to Another Carrier', labelEs: 'Entregado a Otro Transportista'},
    {code: 'ERPU006', labelCn: '包裹未准备好', labelEn: 'Package Not Ready', labelEs: 'Paquete No Listo'},
    {code: 'ERPU010', labelCn: '今日无货', labelEn: 'No Package Today', labelEs: 'Sin Mercancía Hoy'}
];

// 工具函数：根据失败原因代码和语言获取显示文本
export const getPickupFailureReasonText = (reasonCode: string, language: string = 'zh-CN'): string => {
    if (!reasonCode) {
        return '';
    }
    
    // 增加西班牙语处理
    if (language.startsWith('es')) {
        const reason = pickupFailureReasons.find(reason => reason.code === reasonCode);
        return reason ? reason.labelEs : reasonCode;
    }
    
    const isEnglish = language.startsWith('en');
    const reason = pickupFailureReasons.find(reason => reason.code === reasonCode);
    return reason ? (isEnglish ? reason.labelEn : reason.labelCn) : reasonCode;
};